import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Col, Row } from 'reactstrap';

const BreadCrumb = ({ title, pageTitle }: any) => {
    const history = useNavigate();
    function goBack() {
        history(-1);
    }
    return (
        <React.Fragment>
            <Row>
            <Col xs={12}>
  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
    <h4 className="mb-sm-0">{title}</h4>

    <div className="page-title-right d-flex align-items-center">
    {goBack && (
        <button onClick={goBack} className="btn btn-sm btn-primary px-2 text-center ms-3 me-3">
          <i className="ri ri-reply-line fs-6 me-2"></i> Go Back
        </button>
      )}
      <ol className="breadcrumb m-0 me-2">
        <li className="breadcrumb-item">
          <Link to="#">{pageTitle}</Link>
        </li>
        <li className="breadcrumb-item active">{title}</li>
      </ol>

     
    </div>
  </div>
</Col>

            </Row>
        </React.Fragment>
    );
};

export default BreadCrumb;